import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api/axiosInstance";
// import FacebookReviewsWidget from "../components/FacebookReviewsWidget";
import FacebookReviewsIframe from "../components/FacebookReviewsIframe";

// const BACKEND_URL = "http://localhost:8081";
// const BACKEND_URL = "https://api.rangpurgolf.com";

const ReviewRestaurant = () => {
  // const [currentSlide, setCurrentSlide] = useState(0);

  const reviewHeads = [
    "Ambience & Atmosphere",
    "Service & Hospitality",
    "Food & Beverages",
    // "Value for Money",
    // "Overall Experience",
  ];

  const [ratings, setRatings] = useState(
    reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {})
  );
  const [comments, setComments] = useState(
    reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
  );

  // New state for user details
  const [userName, setUserName] = useState("");
  const [userPhone, setUserPhone] = useState("");

  const [userReviews, setUserReviews] = useState([]);

  const handleStarClick = (head, star) => {
    setRatings({ ...ratings, [head]: star });
  };

  const fetchReviews = async () => {
    try {
      const res = await api.get("/reviews");
      setUserReviews(res.data);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  //api fetch reviews from backend
  useEffect(() => {
    // fetch(`${BACKEND_URL}/api/reviews`)
    //   .then((res) => res.json())
    //   .then((data) => setUserReviews(data));
    fetchReviews();
  }, []);

  // const handleSubmit = async () => {
  //   if (!userName || !userPhone) {
  //     alert("Please enter your name and phone number.");
  //     return;
  //   }

  //   const newReview = { userName, userPhone, ratings, comments };

  //   // const res = await fetch(`${BACKEND_URL}/api/reviews`, {
  //   //   method: "POST",
  //   //   headers: { "Content-Type": "application/json" },
  //   //   body: JSON.stringify(newReview),
  //   // });
  //   const res = await api.post("/reviews", newReview);

  //   if (!res.ok) {
  //     const errorMsg = await res.data;
  //     alert("Error saving review: " + errorMsg);
  //     return;
  //   }

  //   const saved = await res.json();
  //   setUserReviews([...userReviews, saved]);

  //   // reset form
  //   setRatings(reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {}));
  //   setComments(
  //     reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
  //   );
  //   setUserName("");
  //   setUserPhone("");

  //   alert("Thank you for your review!");
  // };
  const handleSubmit = async () => {
    if (!userName || !userPhone) {
      alert("Please enter your name and phone number.");
      return;
    }

    const newReview = { userName, userPhone, ratings, comments };

    try {
      const res = await api.post("/reviews", newReview);

      // ✅ res.data already contains the parsed response
      const saved = res.data;
      setUserReviews([...userReviews, saved]);

      // ✅ Reset form
      setRatings(
        reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {})
      );
      setComments(
        reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
      );
      setUserName("");
      setUserPhone("");

      alert("Thank you for your review!");
    } catch (error) {
      console.error("Error saving review:", error);
      // Axios error responses are available as error.response
      const errorMsg =
        error.response?.data?.message ||
        "Failed to save review. Please try again.";
      alert(errorMsg);
    }
  };

  return (
    <div className="bg-[#fffdf6] min-h-screen py-6 px-4 md:px-8 lg:px-20 flex flex-col lg:flex-row gap-6">
      {/* Left Column - User Reviews */}

      <div className="w-full lg:w-1/2 flex flex-col gap-6">
        <div className="bg-white shadow-xl rounded-2xl p-6 flex flex-col">
          {/* <h2 className="text-2xl font-bold text-center text-lime-500 mb-4">
            Review The Restaurant
          </h2> */}
          <div className="flex items-center justify-between border-b pb-2">
            <Link
              to="/restaurant"
              className="text-lime-500 font-bold text-sm hover:underline"
            >
              ← Back to Restaurant
            </Link>
            <h2 className="text-2xl font-bold text-center text-lime-500 mb-4">
              Review The Restaurant
            </h2>
          </div>

          {/* User Info */}
          <input
            type="text"
            placeholder="Your Name"
            className="w-full border rounded-lg p-2 mb-3 text-sm focus:ring-2 focus:ring-lime-400 outline-none"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />
          <input
            type="tel"
            placeholder="Your Phone Number"
            className="w-full border rounded-lg p-2 mb-4 text-sm focus:ring-2 focus:ring-lime-400 outline-none"
            value={userPhone}
            onChange={(e) => setUserPhone(e.target.value)}
          />

          <div className="overflow-y-auto pr-2 space-y-6 max-h-[45vh]">
            {reviewHeads.map((head) => (
              <div key={head} className="border-b pb-4">
                <h3 className="font-semibold mb-2">{head}</h3>

                {/* Stars */}
                <div className="flex gap-1 mb-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      onClick={() => handleStarClick(head, star)}
                      className={`cursor-pointer text-xl ${
                        ratings[head] >= star
                          ? "text-yellow-500"
                          : "text-gray-300"
                      }`}
                    >
                      ★
                    </span>
                  ))}
                </div>

                {/* Comment box */}
                <textarea
                  placeholder={`Write about ${head.toLowerCase()}...`}
                  className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-lime-400 outline-none"
                  rows={2}
                  value={comments[head]}
                  onChange={(e) =>
                    setComments({ ...comments, [head]: e.target.value })
                  }
                ></textarea>
              </div>
            ))}
          </div>

          <button
            onClick={handleSubmit}
            className="mt-4 w-full bg-lime-400 hover:bg-lime-500 text-black py-2 px-4 rounded-lg font-semibold transition"
          >
            Submit Rating
          </button>
        </div>
      </div>

      {/* Right Column - Review Form + Slider */}
      <div className="w-full lg:w-1/2 flex flex-col gap-6">
        <div className="bg-white shadow-xl rounded-2xl p-6 flex flex-col space-y-6">
          <div className="flex items-center justify-between border-b pb-2 ">
            <h2 className="text-xl font-bold text-lime-500">
              What Others Are Saying
            </h2>
            {/* <Link
              to="/restaurant"
              className="text-lime-500 font-bold text-sm hover:underline"
            >
              ← Back to Restaurant
            </Link> */}
          </div>

          {/* ⭐ Average Rating Summary */}
          {userReviews.length > 0 && (
            <div className="bg-gradient-to-r from-lime-100 to-lime-50 border border-lime-200 rounded-xl p-4 flex flex-col space-y-4 shadow-sm">
              {/* Overall Average */}
              {(() => {
                const totalStars = userReviews.reduce((acc, review) => {
                  return (
                    acc +
                    Object.values(review.ratings).reduce(
                      (a, b) => a + (b || 0),
                      0
                    )
                  );
                }, 0);

                const totalRatings = userReviews.reduce((acc, review) => {
                  return (
                    acc +
                    Object.values(review.ratings).filter((r) => r > 0).length
                  );
                }, 0);

                const avg =
                  totalRatings > 0 ? (totalStars / totalRatings).toFixed(1) : 0;

                return (
                  <div className="flex flex-col items-center">
                    <div className="flex items-center gap-2">
                      <span className="text-3xl font-bold text-lime-600">
                        {avg}
                      </span>
                      <span className="text-yellow-500 text-2xl">
                        {"★".repeat(Math.round(avg))}
                        {"☆".repeat(5 - Math.round(avg))}
                      </span>
                    </div>
                    <p className="text-gray-600 text-sm mt-1">
                      Based on {userReviews.length}{" "}
                      {userReviews.length === 1 ? "review" : "reviews"}
                    </p>
                  </div>
                );
              })()}

              {/* Per-Category Averages */}
              <div className="space-y-2">
                {reviewHeads.map((head) => {
                  const headRatings = userReviews
                    .map((r) => r.ratings[head] || 0)
                    .filter((r) => r > 0);
                  const avgHead =
                    headRatings.length > 0
                      ? (
                          headRatings.reduce((a, b) => a + b, 0) /
                          headRatings.length
                        ).toFixed(1)
                      : 0;

                  return (
                    <div
                      key={head}
                      className="flex items-center justify-between"
                    >
                      <span className="text-sm font-medium text-gray-700 w-32">
                        {head}
                      </span>
                      <div className="flex items-center gap-2 flex-1">
                        <div className="text-yellow-500 text-sm">
                          {"★".repeat(Math.round(avgHead))}
                          {"☆".repeat(5 - Math.round(avgHead))}
                        </div>
                        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                          <div
                            className="h-2 bg-lime-500"
                            style={{ width: `${(avgHead / 5) * 100}%` }}
                          ></div>
                        </div>
                        <span className="text-xs text-gray-600 w-6 text-right">
                          {avgHead}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* List of User Reviews */}
          {userReviews.length === 0 ? (
            <p className="text-gray-500 text-center">
              No reviews yet. Be the first to leave one!
            </p>
          ) : (
            <div className="space-y-6 max-h-[65vh] overflow-y-auto pr-2">
              {userReviews.map((review, idx) => (
                <div
                  key={idx}
                  className="border rounded-xl p-4 bg-gradient-to-r from-lime-50 to-white shadow-sm hover:shadow-md transition"
                >
                  <div className="flex justify-between items-center mb-2">
                    <p className="text-sm font-semibold text-lime-600">
                      {review.userName}
                    </p>
                    <p className="text-xs text-gray-400">{review.date}</p>
                  </div>
                  {reviewHeads.map((head) =>
                    review.ratings[head] > 0 || review.comments[head] ? (
                      <div key={head} className="mb-3">
                        <div className="flex items-center justify-between">
                          <span className="font-semibold text-gray-700">
                            {head}
                          </span>
                          <span className="text-yellow-500">
                            {"★".repeat(review.ratings[head])}
                            {"☆".repeat(5 - review.ratings[head])}
                          </span>
                        </div>
                        {review.comments[head] && (
                          <p className="text-sm text-gray-600 mt-1 italic">
                            "{review.comments[head]}"
                          </p>
                        )}
                      </div>
                    ) : null
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        {/* <div>
          <FacebookReviewsWidget />
        </div> */}
        <div className="bg-white shadow-xl rounded-2xl p-6 flex flex-col space-y-6">
          <div className="flex items-center justify-between border-b pb-2 mb-2">
            <h2 className="text-xl font-bold text-blue-500">
              Facebook Reviews
            </h2>
          </div>

          <FacebookReviewsIframe />
        </div>
      </div>
    </div>
  );
};

export default ReviewRestaurant;

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// const BACKEND_URL = "http://localhost:5454";

// const ReviewRestaurant = () => {
//   // const [currentSlide, setCurrentSlide] = useState(0);

//   const reviewHeads = [
//     "Ambience & Atmosphere",
//     "Service & Hospitality",
//     "Food & Beverages",
//     // "Value for Money",
//     // "Overall Experience",
//   ];

//   const [ratings, setRatings] = useState(
//     reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {})
//   );
//   const [comments, setComments] = useState(
//     reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
//   );

//   // New state for user details
//   const [userName, setUserName] = useState("");
//   const [userPhone, setUserPhone] = useState("");

//   const [userReviews, setUserReviews] = useState([]);

//   const handleStarClick = (head, star) => {
//     setRatings({ ...ratings, [head]: star });
//   };

//   //api fetch reviews from backend
//   useEffect(() => {
//     fetch(`${BACKEND_URL}/api/reviews`)
//       .then((res) => res.json())
//       .then((data) => setUserReviews(data));
//   }, []);

//   const handleSubmit = async () => {
//     if (!userName || !userPhone) {
//       alert("Please enter your name and phone number.");
//       return;
//     }

//     const newReview = { userName, userPhone, ratings, comments };

//     const res = await fetch(`${BACKEND_URL}/api/reviews`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(newReview),
//     });

//     if (!res.ok) {
//       const errorMsg = await res.text();
//       alert("Error saving review: " + errorMsg);
//       return;
//     }

//     const saved = await res.json();
//     setUserReviews([...userReviews, saved]);

//     // reset form
//     setRatings(reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {}));
//     setComments(
//       reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
//     );
//     setUserName("");
//     setUserPhone("");

//     alert("Thank you for your review!");
//   };

//   return (
//     <div className="bg-[#fffdf6] min-h-screen py-6 px-4 md:px-8 lg:px-20 flex flex-col lg:flex-row gap-6">
//       {/* Left Column - User Reviews */}
//       <div className="w-full lg:w-1/2 flex flex-col gap-6">
//         <div className="bg-white shadow-xl rounded-2xl p-6 flex flex-col space-y-6">
//           <div className="flex items-center justify-between border-b pb-2">
//             <h2 className="text-xl font-bold text-gray-700">
//               What Others Are Saying
//             </h2>
//             <Link
//               to="/restaurant"
//               className="text-lime-500 font-bold text-sm hover:underline"
//             >
//               ← Back to Restaurant
//             </Link>
//           </div>

//           {/* ⭐ Average Rating Summary */}
//           {userReviews.length > 0 && (
//             <div className="bg-gradient-to-r from-lime-100 to-lime-50 border border-lime-200 rounded-xl p-4 flex flex-col space-y-4 shadow-sm">
//               {/* Overall Average */}
//               {(() => {
//                 const totalStars = userReviews.reduce((acc, review) => {
//                   return (
//                     acc +
//                     Object.values(review.ratings).reduce(
//                       (a, b) => a + (b || 0),
//                       0
//                     )
//                   );
//                 }, 0);

//                 const totalRatings = userReviews.reduce((acc, review) => {
//                   return (
//                     acc +
//                     Object.values(review.ratings).filter((r) => r > 0).length
//                   );
//                 }, 0);

//                 const avg =
//                   totalRatings > 0 ? (totalStars / totalRatings).toFixed(1) : 0;

//                 return (
//                   <div className="flex flex-col items-center">
//                     <div className="flex items-center gap-2">
//                       <span className="text-3xl font-bold text-lime-600">
//                         {avg}
//                       </span>
//                       <span className="text-yellow-500 text-2xl">
//                         {"★".repeat(Math.round(avg))}
//                         {"☆".repeat(5 - Math.round(avg))}
//                       </span>
//                     </div>
//                     <p className="text-gray-600 text-sm mt-1">
//                       Based on {userReviews.length}{" "}
//                       {userReviews.length === 1 ? "review" : "reviews"}
//                     </p>
//                   </div>
//                 );
//               })()}

//               {/* Per-Category Averages */}
//               <div className="space-y-2">
//                 {reviewHeads.map((head) => {
//                   const headRatings = userReviews
//                     .map((r) => r.ratings[head] || 0)
//                     .filter((r) => r > 0);
//                   const avgHead =
//                     headRatings.length > 0
//                       ? (
//                           headRatings.reduce((a, b) => a + b, 0) /
//                           headRatings.length
//                         ).toFixed(1)
//                       : 0;

//                   return (
//                     <div
//                       key={head}
//                       className="flex items-center justify-between"
//                     >
//                       <span className="text-sm font-medium text-gray-700 w-32">
//                         {head}
//                       </span>
//                       <div className="flex items-center gap-2 flex-1">
//                         <div className="text-yellow-500 text-sm">
//                           {"★".repeat(Math.round(avgHead))}
//                           {"☆".repeat(5 - Math.round(avgHead))}
//                         </div>
//                         <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
//                           <div
//                             className="h-2 bg-lime-500"
//                             style={{ width: `${(avgHead / 5) * 100}%` }}
//                           ></div>
//                         </div>
//                         <span className="text-xs text-gray-600 w-6 text-right">
//                           {avgHead}
//                         </span>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}

//           {/* List of User Reviews */}
//           {userReviews.length === 0 ? (
//             <p className="text-gray-500 text-center">
//               No reviews yet. Be the first to leave one!
//             </p>
//           ) : (
//             <div className="space-y-6 max-h-[65vh] overflow-y-auto pr-2">
//               {userReviews.map((review, idx) => (
//                 <div
//                   key={idx}
//                   className="border rounded-xl p-4 bg-gradient-to-r from-lime-50 to-white shadow-sm hover:shadow-md transition"
//                 >
//                   <div className="flex justify-between items-center mb-2">
//                     <p className="text-sm font-semibold text-lime-600">
//                       {review.userName}
//                     </p>
//                     <p className="text-xs text-gray-400">{review.date}</p>
//                   </div>
//                   {reviewHeads.map((head) =>
//                     review.ratings[head] > 0 || review.comments[head] ? (
//                       <div key={head} className="mb-3">
//                         <div className="flex items-center justify-between">
//                           <span className="font-semibold text-gray-700">
//                             {head}
//                           </span>
//                           <span className="text-yellow-500">
//                             {"★".repeat(review.ratings[head])}
//                             {"☆".repeat(5 - review.ratings[head])}
//                           </span>
//                         </div>
//                         {review.comments[head] && (
//                           <p className="text-sm text-gray-600 mt-1 italic">
//                             "{review.comments[head]}"
//                           </p>
//                         )}
//                       </div>
//                     ) : null
//                   )}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Right Column - Review Form + Slider */}
//       <div className="w-full lg:w-1/2 flex flex-col gap-6">
//         <div className="bg-white shadow-xl rounded-2xl p-6 flex flex-col">
//           <h2 className="text-2xl font-bold text-center text-lime-500 mb-4">
//             Rate The Restaurant
//           </h2>

//           {/* User Info */}
//           <input
//             type="text"
//             placeholder="Your Name"
//             className="w-full border rounded-lg p-2 mb-3 text-sm focus:ring-2 focus:ring-lime-400 outline-none"
//             value={userName}
//             onChange={(e) => setUserName(e.target.value)}
//           />
//           <input
//             type="tel"
//             placeholder="Your Phone Number"
//             className="w-full border rounded-lg p-2 mb-4 text-sm focus:ring-2 focus:ring-lime-400 outline-none"
//             value={userPhone}
//             onChange={(e) => setUserPhone(e.target.value)}
//           />

//           <div className="overflow-y-auto pr-2 space-y-6 max-h-[45vh]">
//             {reviewHeads.map((head) => (
//               <div key={head} className="border-b pb-4">
//                 <h3 className="font-semibold mb-2">{head}</h3>

//                 {/* Stars */}
//                 <div className="flex gap-1 mb-2">
//                   {[1, 2, 3, 4, 5].map((star) => (
//                     <span
//                       key={star}
//                       onClick={() => handleStarClick(head, star)}
//                       className={`cursor-pointer text-xl ${
//                         ratings[head] >= star
//                           ? "text-yellow-500"
//                           : "text-gray-300"
//                       }`}
//                     >
//                       ★
//                     </span>
//                   ))}
//                 </div>

//                 {/* Comment box */}
//                 <textarea
//                   placeholder={`Write about ${head.toLowerCase()}...`}
//                   className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-lime-400 outline-none"
//                   rows={2}
//                   value={comments[head]}
//                   onChange={(e) =>
//                     setComments({ ...comments, [head]: e.target.value })
//                   }
//                 ></textarea>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={handleSubmit}
//             className="mt-4 w-full bg-lime-400 hover:bg-lime-500 text-black py-2 px-4 rounded-lg font-semibold transition"
//           >
//             Submit Rating
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReviewRestaurant;
